export enum ExpressionField {
  STUDIO_TYPE = 'STUDIO_TYPE',
  ACTIVITY = 'ACTIVITY',
  SERVICE = 'SERVICE',
  GYM_TYPE = 'GYM_TYPE',
  GYM_INFO = 'GYM_INFO',
  GYM_EQUIPMENT = 'GYM_EQUIPMENT',
  EQUIPMENT_TO_BRING = 'EQUIPMENT_TO_BRING',
  NETWORK = 'NETWORK',
  GENIUS_FEATURES = 'GENIUS_FEATURES',
}

const fieldMap = {
  STUDIO_TYPE: 'Studio Type',
  ACTIVITY: 'Activity',
  SERVICE: 'Service',
  GYM_TYPE: 'Gym Type',
  GYM_INFO: 'Gym Infrastructure',
  GYM_EQUIPMENT: 'Gym Equipment',
  EQUIPMENT_TO_BRING: 'Equipment to Bring',
  NETWORK: 'Network',
  GENIUS_FEATURES: 'Genius Features (internal)',
};

export const fieldToLogicalString = (field?: ExpressionField): string => {
  return field && fieldMap[field] ? fieldMap[field] : '?';
};
